import styled from 'styled-components'
import Link from 'components/Link'

const ToastLink = styled(Link)`
  word-break: break-all;
  white-space: normal;
`

export default ToastLink
